import api from "../../../actions/axios";

// Helper to build query string
const buildQuery = (timeRange, planFilter) => `?timeRange=${timeRange}&plan=${planFilter}`;

// Retry helper: retries 2 times (total 3 attempts)
const fetchWithRetry = async (fn, retries = 2) => {
    try {
        return await fn();
    } catch (err) {
        if (retries > 0 && (!err.response || err.response.status >= 500)) {
            console.warn(`Retrying request... (${retries} left)`);
            return fetchWithRetry(fn, retries - 1);
        }
        throw err;
    }
};

export const getExecutiveData = async (timeRange, planFilter = 'all', signal) => {
    return fetchWithRetry(async () => {
        try {
            const res = await api.get(`/api/v1/admin/dashboard2/executive${buildQuery(timeRange, planFilter)}`, { signal });
            return res.data;
        } catch (err) {
            console.error("Failed to fetch Executive data:", err);
            throw err;
        }
    });
};

export const getEngagementData = async (timeRange, planFilter = 'all', signal) => {
    return fetchWithRetry(async () => {
        try {
            const res = await api.get(`/api/v1/admin/dashboard2/engagement${buildQuery(timeRange, planFilter)}`, { signal });
            return res.data;
        } catch (err) {
            console.error("Failed to fetch Engagement data:", err);
            throw err;
        }
    });
};

export const getMatchingData = async (timeRange, planFilter = 'all', signal) => {
    return fetchWithRetry(async () => {
        try {
            const res = await api.get(`/api/v1/admin/dashboard2/matching${buildQuery(timeRange, planFilter)}`, { signal });
            return res.data;
        } catch (err) {
            console.error("Failed to fetch Matching data:", err);
            throw err;
        }
    });
};

export const getMonetizationData = async (timeRange, planFilter = 'all', signal) => {
    return fetchWithRetry(async () => {
        try {
            const res = await api.get(`/api/v1/admin/dashboard2/monetization${buildQuery(timeRange, planFilter)}`, { signal });
            return res.data;
        } catch (err) {
            console.error("Failed to fetch Monetization data:", err);
            throw err;
        }
    });
};

export const getRetentionData = async (timeRange, planFilter = 'all', signal) => {
    return fetchWithRetry(async () => {
        try {
            const res = await api.get(`/api/v1/admin/dashboard2/retention${buildQuery(timeRange, planFilter)}`, { signal });
            return res.data;
        } catch (err) {
            console.error("Failed to fetch Retention data:", err);
            throw err;
        }
    });
};


// Kept for backward compatibility if needed, but not recommended
export const getDashboardData = async (timeRange, planFilter = 'all') => {
    const [executive, engagement, matching, monetization, retention] = await Promise.all([
        getExecutiveData(timeRange, planFilter),
        getEngagementData(timeRange, planFilter),
        getMatchingData(timeRange, planFilter),
        getMonetizationData(timeRange, planFilter),
        getRetentionData(timeRange, planFilter)
    ]);
    return { executive, engagement, matching, monetization, retention };
};

